/**
 * @author Kimberly Nijzink
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package RoegeInt_b2c
 */

define([
    'jquery',
], function ($) {
    "use strict";

    const switcherTrigger   = '.group-switcher__trigger',
          $switcherTrigger  = $(switcherTrigger),
          switcherLink      = '.group-switcher__link',
          $switcherLink     = $(switcherLink);

    $switcherTrigger.click(function () {
        // Toggle group switcher dropdown
        $switcherTrigger.toggleClass('active');
        $switcherLink.toggleClass('active');
    });

    $(document).click(function(event) {
        // Hide dropdown when clicking outside
        if ($switcherLink.hasClass('active') && !$(event.target).is($('.group-switcher').find('*'))) {
            event.preventDefault();
            $switcherTrigger.removeClass('active');
            $switcherLink.removeClass('active');
        }
    });

    // Hide dropdown when clicking on language switcher
    $('.switcher-language .switcher-trigger').click(function () {
        $switcherTrigger.removeClass('active');
        $switcherLink.removeClass('active');
    });
});
